import { render, staticRenderFns } from "./numberingScoreTable.vue?vue&type=template&id=b669ea42&scoped=true&"
import script from "./numberingScoreTable.vue?vue&type=script&lang=js&"
export * from "./numberingScoreTable.vue?vue&type=script&lang=js&"
import style0 from "./numberingScoreTable.vue?vue&type=style&index=0&id=b669ea42&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b669ea42",
  null
  
)

export default component.exports